/**
 * DatetimeFieldType — data + godzina. Storage: PG TIMESTAMPTZ. Format: ISO 8601.
 * Wpisanie i wyświetlenie na zegarze przeglądarki, w formacie języka aplikacji; do API moment ze strefą.
 */

import { Input } from '@/components/Input';
import {
  formatUserDateTime,
  fromUserDateTimeInput,
  toUserDateTimeInput,
} from '@/lib/user-date-time';

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function DatetimeInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  return (
    <Input
      type="datetime-local"
      value={toUserDateTimeInput(value)}
      onChange={(e) => onChange(fromUserDateTimeInput(e.target.value))}
      disabled={disabled}
      autoFocus={autoFocus}
      invalid={!!error}
      data-testid={`field-${field.slug}-input`}
    />
  );
}

export const DatetimeFieldType: FieldTypeDefinition = {
  type: 'datetime',
  renderInput: (props) => <DatetimeInput {...props} />,
  renderCell: (_field, value) => {
    if (typeof value !== 'string' || !value) return '';
    return formatUserDateTime(value);
  },
  defaultValue: null,
};
